import {
    ButtonBox,
    ContentContainer,
    ContentTitle,
    Description, EndorsmentsBox, ProposedRateDescription,
    ShiftBox, ShiftBoxContainer,
    ShiftBoxDate,
    ShiftBoxDateTimeInfo,
    ShiftBoxRate,
    ShiftBoxRateContainer, ShiftBoxRateDescription,
    ShiftBoxRateTitle,
    ShiftBoxRateValue,
    ShiftBoxRateValueWrapper, ShiftTimeDescription, SubtitleSecondary, Title, TitleContainer
} from "../AvailableJob.styles";
import {DataPointEndorsements, DistanceComponent, MapButton} from "../../ShiftDetailPage/components";
import TagFacesIcon from "@mui/icons-material/TagFaces";
import VerifiedIcon from '@mui/icons-material/Verified';
import CableIcon from "@mui/icons-material/Cable";
import React, {useEffect, useMemo, useState} from "react";
import { JobProps } from "utils/types";
import DateRangeOutlinedIcon from "@material-ui/icons/DateRangeOutlined";
import styles from "../../ShiftDetailPage/ShiftDetail.module.scss";
import dayjs from "dayjs";
import clsx from "clsx";
import {Icon} from "../../AvailableJobsPage/AvailableJobsPage.styles";
import heartFilled from "../../../../images/heartFilled.svg";
import heartUnfilled from "../../../../images/heartUnfilled.svg";
import Api from "../../../../api";
import useActionApi from "../../../../hooks/useActionApi";
import FixedLoader from "../../../../components/FixedLoader/FixedLoader";
import {HYGIENIST_TYPES} from "utils/types";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {getPaymentMethod, getPaymentTerms, getPaymentType} from "../../../../utils";
import { Case, Show, Switch } from "components/Conditionals";

const COUNTRY = {
    US: 1,
    CA: 0
}

export const EndorsementsContainer = ({job, style}: {job: JobProps, style?: React.CSSProperties}) => {
    const isShowed = !!job.location.ppeEndorsed || !!job.location.friendlyEndorsed || !!job.location.equipEndorsed;
    return (isShowed ? <ContentContainer style={style}>
        <ContentTitle>Your fellow TempStars members have worked there and say:</ContentTitle>
        <EndorsmentsBox>
            <DataPointEndorsements
                className={styles.endorsements}
                isShow={!!job.location.ppeEndorsed}
                icon={<VerifiedIcon/>}
                description={'PPE Endorsed'}
            />
            <DataPointEndorsements
                className={styles.endorsements}
                isShow={!!job.location.friendlyEndorsed}
                icon={<TagFacesIcon/>}
                description={'Friendly team'}
            />
            <DataPointEndorsements
                className={styles.endorsements}
                isShow={!!job.location.equipEndorsed}
                icon={<CableIcon/>}
                description={'Good equipment'}
            />
        </EndorsmentsBox>
    </ContentContainer> : null)
}

export const ShiftContainer = ({job}: {job: JobProps}) => {
    const isGuaranteed = !!(job?.ghr);
    const hourlyRate = useMemo(() => {
        return isGuaranteed
        ? `$${job?.ghr}/hr Guaranteed`
        : `$${job.proposedRate || job.avgRate}/hr*`
    }, [isGuaranteed])

    return (
        <ShiftBoxContainer>
            <ShiftBox>
                <div>
                    <ShiftBoxDateTimeInfo>
                        <ShiftBoxDate>
                            <DateRangeOutlinedIcon className={styles.shiftDateIcon}/>
                            {dayjs(job.shifts[0].shiftDate).format('dddd, MMM D')}
                        </ShiftBoxDate>
                        <div>
                            {`${job.shifts[0].postedStart} - ${job.shifts[0].postedEnd}`}
                        </div>
                    </ShiftBoxDateTimeInfo>
                    <ShiftTimeDescription>
                            *Shift start time is the time you need to be at the office, changed into scrubs and ready to work
                    </ShiftTimeDescription>
                </div>
                <div>
                    <ShiftBoxRateContainer>
                        <ShiftBoxRate>
                            <ShiftBoxRateValueWrapper>
                                <ShiftBoxRateTitle>
                                    Proposed Rate
                                </ShiftBoxRateTitle>
                                <ShiftBoxRateValue>
                                    {hourlyRate}
                                </ShiftBoxRateValue>
                            </ShiftBoxRateValueWrapper>
                            <ShiftBoxRateDescription>
                            Office Pays: {getPaymentTerms(job.paymentTerms)} {job.paymentMethod ? `typically via ${getPaymentMethod(job.paymentMethod, job.location.country)}` : ''}                            </ShiftBoxRateDescription>
                            <Show if={job.location.country === COUNTRY.US}>
                                <ShiftBoxRateDescription>
                                    Working Relationship:&nbsp;
                                    <Switch expression={job.paysW2}>
                                        <Case value={0}>1099 Independent Contractor</Case>
                                        <Case value={1}>W2</Case>
                                        <Case value={2}><b>1099</b> or <b>W2</b> (you pick)</Case>
                                    </Switch>
                                    <a href="https://www.tempstars.com/1099-w2/" target="_system" className={"external"}>
                                        <InfoOutlinedIcon sx={{ fontSize: 12 }} />
                                    </a>
                                </ShiftBoxRateDescription>
                            </Show>


                        </ShiftBoxRate>

                        <Show if={!isGuaranteed}>
                            <ProposedRateDescription>
                                ${job.proposedRate}/hr* is the proposed rate by the dental office, but you can choose your own hourly rate <a
                                    target="_system"
                                    className={"external"}
                                    href="https://support.tempstars.com/hc/en-us/articles/4410655181459-How-Does-TempStars-Manage-Hourly-Rates"
                                >learn more</a>
                            </ProposedRateDescription>
                        </Show>
                    </ShiftBoxRateContainer>
                </div>
            </ShiftBox>
        </ShiftBoxContainer>
    )
}

export const TitleBoxContainer = ({job}: {job: JobProps}) => {
    const [updatingJob, setUpdatingJob] = useState<boolean>(false);
    const [isFavouriteDentist, setFavouriteDentist] = useState<boolean>(!!job?.isFavouriteDentist || false)

    useEffect(() => {
        if (job) {
            checkFavouriteLocation(job.locationId)
        }
    }, []);

    const [checkFavouriteLocationLoading, , checkFavouriteLocation] = useActionApi({
        apiMethod: Api.checkFavouriteLocation,
        onSuccess: (data: any) => {
            setFavouriteDentist(data.isFavouriteDentist)
        },
    });

    const updateFavourite = async ({ dentistId, locationId }: JobProps) => {
        setUpdatingJob(true)
        if (isFavouriteDentist) {
            await Api.removeFavouriteDentistByLocationId(locationId);
        } else {
            await Api.setFavouriteDentist(dentistId, locationId);
        }
        checkFavouriteLocation(locationId)
        setUpdatingJob(false);
    }

    return (
        <>
            <TitleContainer>
                <Title>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>{job.location.practiceName}<Icon
                        style={{height: 22}}
                        src={isFavouriteDentist ? heartFilled : heartUnfilled}
                        onClick={() => updateFavourite(job)}
                    />
                    </div>
                    <div>
                        <SubtitleSecondary style={{opacity: 1}}>
                            {`${job.location.city}, ${job.location.province} ${job.location.postalCode}`}
                        </SubtitleSecondary>

                        {/*<DistanceComponent job={job}/>*/}

                        <ButtonBox>
                            <MapButton job={job} className={clsx(styles.removeCancelOfferButton, styles.mapBtn)}/>
                        </ButtonBox>
                    </div>
                </Title>
            </TitleContainer>

            <FixedLoader
                loading={checkFavouriteLocationLoading || updatingJob}
            />
        </>
    )
}
